import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPage } from '@/common/services/tracking';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPage(location.pathname + location.search);
  }, [location]);
};

export default usePageTracking;
